/* Chelsea and Rachel Co. 2024 */


Object.defineProperty(String.prototype, 'capitalize', {
  value: function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});

class CnrConfigurableText {
  constructor() {
    this.labelData = {}
    try {
      let jsonField = document.querySelector("#cnr-labels");
      if (jsonField) {
        this.labels = JSON.parse(jsonField.textContent)  
      }
      
      
    } catch(e) {
      console.error(e)
    }
  }
  textFor(key) {
    if (this.labels[key]) {
      return this.labels[key]
    } else {
      return `missing text for ${key}`
    }
  }
}


class CnR extends CnrConfigurableText {
  api_version = "2024-10";
  keyname = "subscriptions-2024-02";
 constructor(opts={}) {
      super()
      this.config = {...this.defaults(),...opts};
      this.errors=[];
      this.requires().forEach(field=>{
        if (!field in this.config) {
          this.errors.push(`Missing Required config field: ${field}`)
        }
      });
      if (this.errors.length>0) {
        throw new Error(this.errors.join("\n"));
      }
  }
  
  requires() {
    return []
  }
  defaults() {
    return {
      api_version:"2023-10",
      keyname:"subscriptions-2024-02",
      siteRoot:'',
    };
  }
  fetch(url,config) {
    if (this.config.fetch_function) {
      return pure_fetch(url,config)
    } else {
      return fetch(url,config)
    }
  }
  /* shopify cart functions */
  siteUrl(path) {
    if (this.config.siteRoot) {
        return `${this.config.siteRoot}${path}`
    }
    return path
  }
  async getCart(url=this.siteUrl("/cart.js"),extended=false,callback=()=>{}) {
      let cart = {};
      return this.fetch(url)
    .then(res=>(extended)?res.text():res.json());
  }
  async request(url) {
      return this.fetch(this.siteUrl(ur)).then(text=>response.text())
  }
  async updateCart(payload) {
    return this.fetch(this.siteUrl(`/cart/update.js`), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(payload)
    }).then((response) => response.json());
 }
  async removeItemFromCart(key) {
      return this.changeCart({
          id:key,
          quantity:0
        })
  }
  async updateItemCount(key,quantity) {
    return this.changeCart({
      id:key,
      quantity:parseInt(quantity)
    })
  }
  async changeCart(payload) {
      return this.fetch(this.siteUrl(`/cart/change.js`), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(payload)
        }).then((response) => response.json());
   }
   async addToCart(payload) {
      let config = {
          method: 'POST',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
      }
      return this.fetch(this.siteUrl("/cart/add.js"),config)
          .then((response) => response.json())
   }

   static setupDawnProductForm(form) {
      form.querySelector("button").addEventListener("click",event=>{
         event.preventDefault();
         event.stopPropagation();
         new CnR().addToDawnCart(form).then(response=>{

       });
      });
    }
    async addToDawnCart(form) {

       let cart = document.querySelector("cart-drawer");
       const formData = new FormData();
       formData.append('product-id',form.dataset.productId);
       formData.append("id",form.querySelector('[name="id"]').value)
       formData.append("quantity",1);
       try {
         formData.append("selling_plan",form.querySelector('[name="selling_plan"]').value);
       } catch(e) {}

       formData.append('sections',cart.getSectionsToRender().map((section) => section.id));
       formData.append('sections_url',form.dataset.url);
       formData.append('form_type','product');

       return this.fetch(this.siteUrl("/cart/add"),{
           method: 'POST',
           headers: {
               "Accept":"application/javascript",
               "X-Requested-With":"XMLHttpRequest"
           },
           body: formData,form
       })
           .then((response) => response.json())
           .then(json=>{


             if (json.status) {
               CnRModal.show(json.description);
             } else {
               cart.renderContents(json);
               cart.classList.remove("is-empty")
             }
             return json;
       });
    }

   /* graphql functions */
   async graphql(query,params) {
      return fetch(this.siteUrl(`/api/${this.api_version}/graphql.json`),{
          method:"POST",
          headers:{
            "content-type":"application/json",
            "X-Shopify-Storefront-Access-Token":this.config.graphql_token
            },
            body:JSON.stringify({query:query,variables:params})
          })
          .then(response=>response.json())
  }
  graphql_sync(query,params) {
      let ajax = new XMLHttpRequest();
      ajax.headers = {
          "content-type":"application/json",
          "X-Shopify-Storefront-Access-Token":this.config.graphql_token
      }
      ajax.open("POST",this.siteUrl(`/api/${this.api_version}/graphql.json`),false)
      ajax.setRequestHeader("Content-Type", "application/json");
      ajax.setRequestHeader("X-Shopify-Storefront-Access-Token", storefront_token);
      ajax.send(JSON.stringify({query:query,params:params}));
      return JSON.parse(ajax.responseText);
  }
  gid2id(gid) {
    return parseInt(gid.split("/").pop())
  }
  collapse_query(object) {
    if (object==null) {
        return object;
    }
    switch(object.constructor.name) {
    case "Array":
        return object.map(item=>this.collapse_query(item));
        break;
        case "Object":
            let ret = {};
            Object.keys(object).forEach(key=>{
                if (object[key]==null) {
                    ret[key] = null;
                    return;
                }
                if (object[key].reference) {
                    ret[key] = this.collapse_query(object[key].reference)
                    return;

                }
                if (object[key].references) {
                    let all = [];
                    object[key].references.nodes.forEach(ref=>{
                        let crv = {};
                        if (ref.fields) {
                          ref.fields.forEach(field=>{
                            crv[field.key]=this.collapse_query(field.value)
                          })  
                        } else {
                          Object.keys(ref).forEach(field=>{
                            
                            if (ref[field]) {
                              if (ref[field].value) {
                                crv[field]=this.collapse_query(ref[field].value)    
                              } else {
                                let newHash = {}
                                Object.keys(ref[field]).forEach(key=>{
                                  newHash[key] = this.collapse_query(ref[field][key])
                                });
                                crv[field] = newHash
                              }
                              
                              
                            } else {
                              crv[field] = null
                            }
                            
                          })
                        }
                        
                        all.push(crv)
                    })
                    object[key] = all;

                }
                if (object[key].type && object[key].type=="json") {
                  object[key] = JSON.parse(object[key ])
                }
                if (object[key].nodes && object[key].nodes.constructor.name=="Array") {
                    ret[key] = this.collapse_query(object[key].nodes);
                } else {
                    ret[key] = this.collapse_query(object[key])
                }
            });
            return ret
            break;
        default:
            if (object) {
                return object;
            }

            break;
    }
}
   css() {
      return '';
   }
   inject_css() {
      let css = this.css();
      if (css.length>0) {
          let style = document.createElement("style");
          style.id=this.constructor.name.toLowerCase();
          style.textContent = this.css();
          document.querySelector("head").appendChild(style);
      }

   }
   
}
class CnrStorefront extends CnR {
  requires() {
    return ["graphql_token"]
  }
}
/* src/cnr-pdp-subscription-widget/pdp-subscription-widget.js  */
class CnRSubscriptionsWidget extends CnR {
  defaults() {
      return {
          default_to_subscription:true,
          onetime_label:"One Time Purchase",
          subscription_label:"Autoship & save",
          delivery_label: "",
          injection_point:".cnr-subscription-widget",
          form_selector:"[data-product-form]",
          krc:true,
          selling_group_index:1,
          "id":"default-widget",
      };
  }
  constructor(options) {
      super(options);
      this.selling_plans = {}
      this.optionIndex = 0;
      this.root = document.querySelector(this.config.injection_point);
      this.load_product(this.config.product)
          .then(q=>{
              let hasSellingPlans = true;
            
              this.config.product = q.data.product;
              this.config.variants = q.data.product.variants.nodes.map(variant=>this.addVariant(variant));

              if (!this.config.variant_id) {
                  this.config.selected_variant = this.config.variants[0];
              } else {
                  this.config.selected_variant = this.config.variants.find(variant=>variant.id==this.config.variant_id)
              }
              if (q.data && q.data.product) {
                  if (q.data.product.sellingPlanGroups.nodes.length>0) {
                      this.selling_plans = this.parseSellingPlans(q);
                      if (!this.config.selling_plan_id) {
                          if (this.config.default_to_subscription) {
                              this.config.selling_plan= this.selling_plans.options[0];
                              this.config.last_selling_plan = this.config.selling_plan;
                          } else {
                              this.config.last_selling_plan= this.selling_plans.options[0];
                          }
                      } else {
                          this.config.selling_plan = this.selling_plans.options.find(plan=>plan.id==this.config.selling_plan_id);
                          this.config.last_selling_plan = this.config.selling_plan;
                      }
                  } else {
                    hasSellingPlans = false;
                  }
              }
              if (!hasSellingPlans) {
                return;
              }
              this.afterLoad();
              document.addEventListener("CartUpdated",event=>{
                  this.cart = event.detail;
                  this.render();
              });
              document.addEventListener("VariantChanged",event=>{
                  this.config.selected_variant = this.config.variants.find(variant=>variant.id==parseInt(event.detail))
                  this.render();
              });
              this.monitorForm();
              this.killReCharge();
              this.render();
          });
  }
  afterLoad() {}
  addVariant(variant) {
      return {
          id:this.gid2id(variant.id),
          price:parseFloat(variant.price.amount)
      }
  }
  parseSellingPlans(q) {
      return this.parseSellingPlansV2(q);
  }
  parseSellingPlansV1(q) {
      let group = q.data.product.sellingPlanGroups.nodes.pop();
      let variantMap = {}
      q.data.product.variants.nodes.forEach(variant=>{
        if (variant.sellingPlanAllocations!=null) {
          variant.sellingPlanAllocations.nodes.forEach(sellingPlan=>{
            let id = this.gid2id(sellingPlan.id)
              if (variantMap[id]!=null) {
                variantMap[id].push(this.gid2id(variant.id))
              } else {
                variantMap[id].push[this.gid2id(variant.id)]
              }
          })
        }
      })
      return {
          group_id:group.name,
          options:group.sellingPlans.nodes.map(selling_plan=>{
              return {
                  id:this.gid2id(selling_plan.id),
                  label:selling_plan.options[0].value,
                  discount:selling_plan.priceAdjustments[0].adjustmentValue.percent/100,
              };
          }),
          variantMap:this.mapVariants(q)
      };
  }
  parseSellingPlansV2(q) {
      let by_app = {};

      q.data.product.sellingPlanGroups.nodes.forEach(group=>{
          if (!by_app[group.appName]) {
              by_app[group.appName] = []
          }
          if (this.isValidGroup(group)) {
            by_app[group.appName].push({
                id:this.gid2id(group.sellingPlans.nodes[0].id),
                "label":group.name,
                "discount":group.sellingPlans.nodes[0].priceAdjustments[0].adjustmentValue.percent/100,
                "interval":group.sellingPlans.nodes[0].deliveryPolicy.intervalCount
            });
          }
      });
      

    
      return {
          group_id:this.config.subscription_label,
          options:this.sorted((this.config.use_app)?by_app[this.config.use_app]:Object.values(by_app).pop()),
          variantMap:this.mapVariants(q)
      };
  }
  sorted(options) {
    return options;
  }
  isValidGroup(group) { return true}
  
  mapVariants(q) {
    let variantMap = {}
    q.data.product.variants.nodes.forEach(variant=>{
        if (variant.sellingPlanAllocations!=null) {
          variant.sellingPlanAllocations.nodes.forEach(allocation=>{
              let sellingPlan = allocation.sellingPlan
              let id = this.gid2id(sellingPlan.id)
              if (variantMap[id]!=null) {
                variantMap[id].push(this.gid2id(variant.id))
              } else {
                variantMap[id]=[this.gid2id(variant.id)]
              }
          })
        }
      })
    return variantMap;
  }
  load_product(id) {
      return this.graphql(`
  query getProducts($id: ID!) {
    product(id:$id) {
      id
      variants(first:100) {
        nodes {
          id
          price {
            amount
          }
          sellingPlanAllocations(first:10) {
            nodes {
              sellingPlan {
                id
              }
            }
          }
          ${this.additionalVariantQuery()}
        }
      }
      ${this.additionalProductQuery()}
      sellingPlanGroups(first: 10) {             
        nodes {
          appName
          name
          sellingPlans(first:250) {
            nodes {  
              recurringDeliveries
              billingPolicy {
                ... on SellingPlanRecurringBillingPolicy {
                  interval
                  intervalCount
                }
              }
              deliveryPolicy {
                ... on SellingPlanRecurringDeliveryPolicy {
                  interval
                  intervalCount
                }
              }
              id
              options {
                value
              }
              description
              priceAdjustments {
                adjustmentValue {
                  ... on SellingPlanPercentagePriceAdjustment {
                    percent: adjustmentPercentage
                  }
                  ... on SellingPlanFixedPriceAdjustment {
                    amount: price {
                      amount
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`,
          {id:`gid://shopify/Product/${id}`}
      );
  }
  additionalVariantQuery() { return '';}
  additionalProductQuery() { return '';}
  regular_price(variant=null) {
      return this.config.selected_variant.price;
  }
  display_regular_price() {
      return `$${this.regular_price().toFixed(2)}`
  }
  apply_discount(price,selling_plan) {
      return price*(1-((selling_plan)?selling_plan.discount:0));
  }
  discounted_price() {
      let selling_plan = this.config.selling_plan;
      if (!selling_plan) {
          selling_plan = this.config.last_selling_plan;
      }
      return this.apply_discount(this.config.selected_variant.price,selling_plan);
  }
  current_price() {
      if (this.config.selling_plan) {
          return this.discounted_price();
      } else {
          return this.regular_price();
      }
  }
  frequency_label() {
      return this.config.selling_plan?this.config.selling_plan.label:'';
  }
  display_discounted_price() {
      return `$${this.discounted_price().toFixed(2)}`
  }
  subscription_label() {
      return `${this.config.subscription_label}`;
  }
  onetime_label() {
      return this.config.onetime_label;
  }
  killReCharge() {
      this.rci = window.setInterval(()=>{
          let recharge = document.querySelector(".rc-container-wrapper");
          if (recharge) {
              recharge.parentElement.removeChild(recharge);

              window.clearInterval(this.rci)
          }
      },200)

  }
  getFormVariantField() {
    return document.querySelector(this.config.form_selector).querySelector('[name="id"]')
  }
  monitorForm() {
      let id = document.querySelector(this.config.form_selector).querySelector('[name="id"]');
      let initialValue = null;
      const update = (variant_id)=>{
          this.config.selected_variant = this.config.variants.find(variant=>variant.id==variant_id)
          this.render();
      }
      switch(id.tagName) {
          case "SELECT":
              id.addEventListener("change",event=>{
                  console.error("select change")
                  update(parseInt(id.options[id.selectedIndex].value))
              })
              initialValue = id.options[id.selectedIndex].value
              break;
          default:
              this.variant_observer = new MutationObserver((list,observer)=>{
                  console.error("OBSERVED");
                  let variant_id = parseInt(id.value);
                  this.config.selected_variant = this.config.variants.find(variant=>variant.id==variant_id)
                  this.render();
              });
              initialValue = id.value
              this.variant_observer.observe(id,{attributes:true,subtree:false,childList:true});
      }
      this.config.selected_variant = this.config.variants.find(variant=>variant.id==parseInt(initialValue))


  }
  onetime_label_extra() {
      return ``;
  }
  subscriptions_label_extra() {
      return `<ul class="subscription-widget-benefits"><li>Easy cancellations through the website</li><li>Access to VIP-only sales</li><li>Receive free gifts</li></ul>`;
  }
  onetime_block_extra() {
      return ``;
  }
  subscriptions_block_extra() {
      return ``; }
  container_extra() {
      return '';
  }
  delivery_string() {
      return 'Delivers every'
  }
  format_label(label) {
      return label;
  }
  broadcastPlan(id) {
      document.dispatchEvent(new CustomEvent("cnr:subscriptions:planUpdated",{bubbles:true,detail:id}))
  }
  broadcastPrice() {
      
      document.dispatchEvent(new CustomEvent("cnr:subscriptions:priceUpdated",{bubbles:true,detail:this.current_price()}))
  }
  
  renderSellingPlanSelector(plans) {
      let selected_plan = this.config.selling_plan||this.config.last_selling_plan;
      return `
      <div class="options-selector ${plans.length>1?'multiple-options':''}">
        <select name="selling_plan_id" id="rc_shipping_interval_frequency" class="rc_select rc_select__frequency styled replaced">
          ${plans.map(plan=>{
          return `
              <option value="${plan.id}" ${(selected_plan.id==plan.id)?'selected':''}>
                ${this.config.delivery_label} ${this.format_label(plan.label)}
              </option>`
      }).join('')}
        </select>
      </div>`;
  }
  planInput() {
      return document.querySelector(this.config.form_selector).querySelector('[name="selling_plan"]');
  }
  render() {

      let innerHtml = `
    <div id="rc_container" data-default-to-sub="${this.config.default_to_subscription}">
      <div id="rc_radio_options" role="radiogroup" aria-labelledby="Purchase options">
        <div class="rc_block rc_block__type onetime-block -option rc_block__type__onetime ${!this.config.selling_plan?'rc_block__type--active':''}" >
        <div class="description">
          <span class="radio">
            <input type="radio" id="rc_purchase_type_onetime" name="purchase_type" value="onetime" data-selling-plan="" class="rc_radio rc_radio__onetime" ${!this.config.selling_plan?'checked':''} data-purchase-type="onetime">
          </span>
          <label for="rc_purchase_type_onetime" class="rc_label rc_label__onetime body2">
            <span class="rc_description">${this.onetime_label()}</span>
            <span id="rc_extra">${this.onetime_label_extra()}</span>
          </label>
          <div class="block-extra-content">${this.onetime_block_extra()}</div>
        </div>
      </div>
      <div class="rc_block rc_block__type subscription-block rc_block__type__autodeliver ${this.config.selling_plan?'rc_block__type--active':''} ${this.selling_plans.options && this.selling_plans.options.length>0?'':'d-none'}" >
        <div class="description">
          <span class="radio">
            <input type="radio" name="purchase_type" id="rc_purchase_type_autodeliver" value="autodeliver"  class="rc_radio rc_radio__autodeliver" ${this.config.selling_plan?'checked':''} data-purchase-type="autodeliver">
          </span>
          <label for="rc_purchase_type_autodeliver" class="rc_label rc_label__autodeliver body2">
              <span class="rc_description">
                <div class="">${this.subscription_label()}</div>
                <div class="display-price">${this.display_discounted_price()}</div>
              <span id="rc_price_autodeliver" class="rc_price rc_price__autodeliver" aria-label="recurring price"></span>
              <span id="rc_extra">${this.subscriptions_label_extra()}</span>
            </label>
            <div class="block-extra-content">${this.subscriptions_block_extra()}</div>
          </div>
          <div id="rc_autodeliver_options" class="rc_block__type__options">
              ${this.renderSellingPlanSelector(this.selling_plans.options)}
          </div>
        </div>
        <div class="container-extra">${this.container_extra()}</div>
      </div>
        ${this.extraHTML()}
      </div>
  `;
      console.error(innerHtml)
      this.root.innerHTML = innerHtml;
      let plan_input = this.planInput();
      if (!plan_input) {window.clearInterval(this.id);
          plan_input = document.createElement("input");
          plan_input.type="hidden";
          plan_input.name="selling_plan";
          document.querySelector(this.config.form_selector).appendChild(plan_input);
      }
      
      if (plan_input && this.config.selling_plan) {
          plan_input.value = this.config.selling_plan.id;
          this.broadcastPlan(plan_input.value)
          this.broadcastPrice()
      }
      this.setupEvents();
  }
  verifyVariant(value) {
    let variantField = this.getFormVariantField()
    let variantId = parseInt(variantField.value)
    let variantMapped = this.selling_plans.variantMap[parseInt(value)]
    if (variantMapped) {
      if (!variantMapped.includes(variantId)) {
        variantField.value = variantMapped[0]
      }
    }
    
  }
  setupSelectorEvents() {
      this.root.querySelector("#rc_shipping_interval_frequency").addEventListener("change",event=>{
          let value = event.target.options[event.target.selectedIndex].value;
          this.config.last_selling_plan = this.config.selling_plan;
          this.config.selling_plan = this.selling_plans.options.find(plan=>plan.id==parseInt(value));
          console.error("hey now")
          this.broadcastPlan(value)
          this.broadcastPrice()
          
          this.planInput().value = value;
          this.verifyVariant(value)
          this.render()
      })
  }
  setupEvents() {
      this.setupSelectorEvents();
      this.root.querySelectorAll('input[name="purchase_type"]').forEach(radio=>{
          radio.addEventListener("change",event=>{

              switch(radio.dataset.purchaseType) {
                  case "onetime":
                      this.config.last_selling_plan = this.config.selling_plan;
                      this.config.selling_plan = null;

                      this.planInput().value="";
                      break;
                  case "autodeliver":

                      if (this.config.last_selling_plan) {
                          this.config.selling_plan = this.config.last_selling_plan;
                      } else {
                          this.config.selling_plan = this.selling_plans.options[0];
                      }
                      this.planInput().value = this.config.selling_plan.id;
                      this.verifyVariant(this.planInput().value)
                      break;

              }
              this.broadcastPrice();
              this.broadcastPlan(this.planInput().value)
              this.render();

          });
      })

  }

  extraHTML() {
      return '';
  }
}

class RedBarnSubscriptionWidget extends CnRSubscriptionsWidget {
  renderSellingPlanSelector(plans) {
      let selected_plan = this.config.selling_plan||this.config.last_selling_plan;
      
      return `<div class="selling-plan-selector">
          ${plans.map(plan=>`
        <div class="selling-plan-option-row" data-selling-plan-id="${plan.id}">
            <label for="selling_plan_${plan.id}">
              <input type="radio" class="selling-plan-option" name="selling_plan_option" id="selling_plan_${plan.id}" value="${plan.id}" ${(selected_plan.id==plan.id)?'checked':''}>
              ${this.config.delivery_label} ${this.format_label(plan.label)}
            </label>
        </div>`).join('')}
        </div>`;
  }
  setupSelectorEvents() {
      this.root.querySelectorAll(".selling-plan-option").forEach(selector=>selector.addEventListener("change",event=>{
          let value = selector.value;
          this.config.last_selling_plan = this.config.selling_plan;
          this.config.selling_plan = this.selling_plans.options.find(plan=>plan.id==parseInt(value));
          this.broadcastPlan(value)
          this.broadcastPrice()
          this.planInput().value = value;

          this.render()
      }))
  }
  isValidGroup(group) {
    if (group.sellingPlans.nodes.length>1) {
      return false
    }
    return true;
  }
  sorted(options) {
    return options.sort((a,b)=>a.interval-b.interval)
  }
  subscription_label() {
    return `
          Subscribe To Save 10%
    `
    
  }
  subscriptions_label_extra() { return ''}
}
